import React from "react";
import { NotFoundPage } from "pages";
import { Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import templates from "config/templates";
import useSetActivePage from "../hooks/useSetActivePage";
import usePageView from 'hooks/usePageView';

function Pages() {
  const { routes, initial } = useSelector((state) => state.globalContent);

  useSetActivePage();
  usePageView();

  if (!initial) return null;

  return (
    <>
      <Routes>
        {routes.map((route) => {
          const RouteComponent = templates[route.template]?.component;

          if (!RouteComponent) {
            return null;
          }

          return (
            <Route
              key={route.path}
              exact
              {...route}
              element={<RouteComponent />}
            />
          );
        })}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}

export default Pages;
